import React from 'react'
import { connect } from 'react-redux'
import {
    FacebookShareButton,
    // LineShareButton,
    // LinkedinShareButton,
    // PocketShareButton,
    // TumblrShareButton,
    TwitterShareButton,
    // ViberShareButton,
    // WhatsappShareButton,
} from "react-share";
import {
    FacebookIcon,
    // LineIcon,
    // LinkedinIcon,
    // PocketIcon,
    // TumblrIcon,
    TwitterIcon,
    // ViberIcon,
    // WhatsappIcon,
} from "react-share";
import stylesPc from '../styles/shareIconsStyle'
import stylesPhone from '../styles/shareIconsStyleSmartPhone'

var styles;

type Props = {
    result: String;
    bgColor: String,
};

type State = {
};

class ShareIcons extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        return (
            <div style={styles.main}>
                <p>結果をシェア：</p>
                <FacebookShareButton quote={this.props.result} hashtag={"#Empath #REmotalkie"} url={"https://remotalkie.webempath.ai/"}>
                    <FacebookIcon size={32} roundsize={32} round />
                </FacebookShareButton>
                <TwitterShareButton title={this.props.result} hashtags={["Empath", "REmotalkie"]} url={"https://remotalkie.webempath.ai/"}>
                    <TwitterIcon size={32} roundsize={32} round />
                </TwitterShareButton>
                {/* <LinkedinShareButton title={"Title"} summary={"sum"} source={"https://webempath.com/"} url={"https://remotalkie.webempath.ai/"}>
                    <LinkedinIcon size={32} roundsize={32} round />
                </LinkedinShareButton> */}
                {/* <LineShareButton title={this.props.result} url={"https://remotalkie.webempath.ai/"}>
                    <LineIcon size={32} roundsize={32} round />
                </LineShareButton> */}
            </div >
        );
    }
}

ShareIcons.defaultProps = {
    result: "test\ntest",
}
const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(ShareIcons);